import { supabase } from "@/shared/lib/supabaseClient";

export interface Aniversariante {
  pessoa_id: string;
  nome_completo: string;
  /** Dia do mês (1-31). Nunca vem acompanhado do ano — ver migration 0026. */
  dia: number;
  /** Mês (1-12). */
  mes: number;
  /** Dia da semana da data do aniversário (0 = domingo ... 6 = sábado), já calculado no banco. */
  posicao: number;
}

/**
 * Aniversariantes da Semana (pedido do usuário, 26/07/2026): quem faz
 * aniversário na semana de segunda a domingo (migration 0105, 10/10/2026; antes
 * era domingo a sábado). O RPC
 * `aniversariantes_da_semana` (migration 0026) já filtra pela igreja atual
 * e por pessoa ativa, e devolve só nome + dia/mês/posição — nunca ano de
 * nascimento ou idade, por design (a função no banco não expõe isso).
 */
export const aniversariantesService = {
  async listarDaSemana(): Promise<Aniversariante[]> {
    const { data, error } = await supabase.rpc("aniversariantes_da_semana");
    if (error) throw new Error("Não foi possível carregar os aniversariantes da semana.");
    return data ?? [];
  },
};
